import React from 'react'

const SelectCell = ({children, ...rest}) => {
    return <td {...rest}>{children}</td>
}

export default SelectCell;